"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Component2 = _interopRequireDefault(require("../../Component"));

var _index = _interopRequireDefault(require("../style/index"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _qr_code_generator = _interopRequireDefault(require("../vendor/qr_code_generator"));

var _createStyled = require("../../../utils/createStyled");

var IMAGE_MODE = 'image';
var HTML_MODE = 'html';

var QRCode =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(QRCode, _Component);

  function QRCode() {
    (0, _classCallCheck2["default"])(this, QRCode);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(QRCode).apply(this, arguments));
  }

  (0, _createClass2["default"])(QRCode, [{
    key: "render",
    value: function render() {
      var styles = this.compileStyled(_index["default"]),
          _this$props = this.props,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          ecclevel = _this$props.ecclevel,
          margin = _this$props.margin,
          modulesize = _this$props.modulesize,
          code = _this$props.code,
          mode = _this$props.mode;
      var isImageMode = mode === IMAGE_MODE;
      return _react["default"].createElement(_react["default"].Fragment, null, isImageMode ? _react["default"].createElement(_createStyled.Styled.Div, {
        className: className,
        src: _qr_code_generator["default"].generatePNG(String(code), {
          ecclevel: ecclevel,
          margin: margin,
          modulesize: modulesize
        })
      }) : _react["default"].createElement(_createStyled.Styled.Div, {
        styles: styles.root,
        className: className,
        dangerouslySetInnerHTML: {
          __html: _qr_code_generator["default"].generateHTML(String(code), {
            ecclevel: ecclevel,
            margin: margin,
            modulesize: modulesize
          })
        }
      }));
    }
  }]);
  return QRCode;
}(_Component2["default"]);

(0, _defineProperty2["default"])(QRCode, "defaultProps", {
  code: null,
  ecclevel: 'L',
  margin: 0.0001,
  modulesize: 4,
  mode: HTML_MODE
});
(0, _defineProperty2["default"])(QRCode, "propTypes", {
  className: _propTypes["default"].string,
  code: _propTypes["default"].any,
  ecclevel: _propTypes["default"].string,
  margin: _propTypes["default"].number,
  modulesize: _propTypes["default"].number,
  mode: _propTypes["default"].oneOf([IMAGE_MODE, HTML_MODE]),

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default palette.elPrimary
     */
    background: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    pixelBackground: _propTypes["default"].string,

    /**
     * @default 3px
     */
    borderRadius: _propTypes["default"].string,

    /**
     * @default palette.gutter + 'px'
     */
    padding: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  })
});
(0, _defineProperty2["default"])(QRCode, "displayName", 'QRCode');
var _default = QRCode;
exports["default"] = _default;